<template>
<Cart :cart="cart" @remove-from-cart="handleRemoveFromCart" @empty-cart="handleEmptyCart" @checkout="handleNavigateTocheckout" @refresh-cart="refreshCart" />
</template>

<script>
import Cart from '../components/Cart';

export default {
    name: 'ShopCart',
    components: {
        Cart,
    },
    computed: {
        cart() {
            return this.$store.getters['app/cart'] || {};
        },
    },
    methods: {
        /**
         * Refreshes the cart
         */
        refreshCart() {
            this.$emit('refresh-cart');
        },
        /**
         * Close cart when routing to checkout
         */
        handleNavigateTocheckout() {
            this.$router.push('/checkout')
            this.isCartVisible = false;
        },
        /**
         * Empties cart contents
         * https://commercejs.com/docs/sdk/cart/#remove-from-cart
         */
        handleEmptyCart() {
            this.$commerce.cart.empty().then((resp) => {
                this.refreshCart();
            }).catch((error) => {
                console.log('There was an error clearing your cart', error);
            });
        },
        /**
         * Removes line item from cart
         * https://commercejs.com/docs/sdk/cart/#remove-from-cart
         *
         * @param {string} lineItemId ID of the line item being removed
         */
        handleRemoveFromCart(lineItemId) {
            this.$commerce.cart.remove(lineItemId).then((resp) => {
                this.refreshCart();
            }).catch((error) => {
                console.log('There was an error updating the cart items', error);
            });
        },
    }
}
</script>
